export default __webpack_public_path__ + "../staticImages/hawesko-logo-app.svg";